import { Outlet } from 'react-router-dom';
import { useNewNotificationToasts } from '@/hooks/useNewNotificationToasts';
import { useNotificationTabTitle } from '@/hooks/useNotificationTabTitle';
import { useWorkspaceBrandTheme } from '@/hooks/useWorkspaceBrandTheme';
import { ClientBottomNavigation } from './ClientBottomNavigation';
import { ClientShellHeader } from './ClientShellHeader';
import { ClientTopNavigation } from './ClientTopNavigation';

export function ClientShell() {
  useNewNotificationToasts();
  useNotificationTabTitle();
  useWorkspaceBrandTheme();

  return (
    <div className="h-screen overflow-hidden flex flex-col bg-zoooffwhite font-sans">
      <ClientShellHeader />
      <ClientTopNavigation />
      <main className="flex-1 min-h-0 overflow-y-auto flex flex-col pb-[calc(3.25rem+env(safe-area-inset-bottom))] lg:pb-0">
        <div className="max-w-7xl mx-auto w-full flex-1">
          <Outlet />
        </div>
      </main>
      <ClientBottomNavigation />
    </div>
  );
}
